import React, { useState, useEffect } from "react";
// import { useEffect, useState, useMemo } from "react";

import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import type { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { getParameter } from "../../store/app/general";

const containerStyle = {
  width: "600px",
  height: "300px",
  maxWight: "100%",
  class: "map",
};

function GMaps(props: any) {
  const center = {
    lat: props.coords.lat,
    lng: props.coords.lng,
  };
  const [zoom, setZoom] = useState(14);
  const [maploaded, setMapLoad] = useState(false);
  const googleapikey = useSelector((state: RootState) =>
    getParameter(state, "SGOOGLE_MAPS_APIKEY"),
  );

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googleapikey,
  });

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(
    function callback(map: any) {
      // This is just an example of getting and using the map instance!!! don't just blindly copy!
      const bounds = new window.google.maps.LatLngBounds(center);
      map.fitBounds(bounds);
      setMapLoad(true);
      setMap(map);
    },
    [map],
  );

  const onUnmount = React.useCallback(function callback(map: any) {
    setMap(null);
  }, []);

  const markerMount = React.useCallback(
    function callback(map: any) {
      console.log("mount");
    },
    [zoom, map],
  );

  //   console.log(center);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={18}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {maploaded ? <Marker onUnmount={markerMount} position={center} /> : ""}
      <></>
    </GoogleMap>
  ) : (
    <></>
  );
}

export default GMaps;
